<template>
  <div class="pc-login">
    <!-- <span
      v-if="!whichLanguage && type !== 'protocol-header'"
      class="header-language header-each-tab  bonus-cursor lang"
      @click="changeLanguage('zn')"
    >中文
    </span> -->
    <!-- <span
      v-if="whichLanguage && type !== 'protocol-header'"
      class="header-language header-each-tab  bonus-cursor lang"
      @click="changeLanguage('en')"
    >English
    </span> -->
    <!-- <div
      class="change_language cursor"
      @mouseenter="showDetails"
      @mouseleave="hideDetails"
    >{{ $t('language') }}
      <div
        class="choose-language"
        v-if="showLanguage"
        @mouseenter="showDetails"
      >
        <a
          target="_blank"
          href="http://bonuscloud.com.ua/?lang=ru"
        >{{ $t('ru')}}</a>
        <a
          target="_blank"
          @click="changeLanguage('zn')"
        >{{ $t('cn')}}</a>
        <a
          target="_blank"
          @click="changeLanguage('en')"
        >{{ $t('en')}}</a>
      </div>
    </div> -->
    <a
      class="download_tab"
      target="_blank"
      href="https://rcofkvbmsa.feishu.cn/wiki/DcCOwVuquibGc2k69wNc6DQDntb?from=from_copylink"
    >业务汇总</a>
    <a
      class="download_tab"
      target="_blank"
      href="https://console.bonuscloud.work/download"
    >{{ $t('download')}}</a>
    <a
      class="resource_tab"
      target="_blank"
      :href=" $t('resource_link')"
    >{{ $t('resource')}}</a>
    <a
      class="faq resource_tab"
      target="_blank"
      href="https://bonuscloud.work/tutorial/index.html"
    >FAQ</a>
    <a
      class="resource_tab club"
      target="_blank"
      :href=" $t('club')"
    >BONUSCLOUD CLUB</a>
    <a
      class="login"
      target="_blank"
      :href="consoleHost + '/login'"
      
    >{{ $t('login')}}</a>
    <div class="login_line"></div>
    <a
      class="signup"
      target="_blank"
      :href="consoleHost + '/signUp'"
    >{{ $t('signUp')}}</a>
  </div>
</template>

<i18n>
{
  "en": {
    "language": "LANGUAGE",
    "download": "DOWNLOAD",
    "login": "LOGIN",
    "signUp": "SIGN UP",
    "resource": "RESOURCE",
    "ru": "RU",
    "cn": "CN",
    "en": "EN",
    "club": "https://bonuscloud.club/viewforum.php?f=7",
    "resource_link": "https://shimo.im/docs/tccpQpcDykGRPQQC"
  },
  "zn": {
    "language": "语言",
    "download": "下载中心",
    "login": "登录",
    "signUp": "注册",
    "resource": "资源汇总",
    "ru": "俄语",
    "cn": "中文",
    "en": "英文",
    "club": "https://bonuscloud.club/viewforum.php?f=6",
    "resource_link": "https://shimo.im/docs/CrgKvjCGXVYhQ3PX"
    
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  data() {
    return {
      showLanguage: false,
      // whichLanguage: false
    };
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    consoleHost: state => {
      if (state && state.isZnWebsite) {
        return 'https://console.bonuscloud.work';
      } else {
        return 'https://console.bonuscloud.io';
      }
    }
  }),
  methods: {
    ...mapActions([]),
    showDetails() {
      this.showLanguage = true;
    },
    hideDetails() {
      this.showLanguage = false;
    },
    // changeLanguage(locale) {
    //   this.whichLanguage = locale === "zn";
    //   this.$i18n.locale = locale;
    //   this.$cookie.set("BASIC_LANUAGE", locale);
    //   window.location.href = `?language=${locale}`;
    // }
  },
  created() {
    // 缓存语言设置
    // let language = this.$cookie.get("BASIC_LANUAGE");
    // this.$i18n.locale = language;
    // this.whichLanguage = language === "zn";
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.pc-login {
  position: absolute;
  // padding: 30px 50px 0;
  font-size: 14px;
  right: 60px;
  top: 30px;
  line-height: 35px;
  z-index: 1000;
  color: #fff;
  line-height: 35px;
  letter-spacing: 1px;

  a.logo {
    display: inline-block;
    width: 180px;
    height: 30px;
    background: url('../../assets/common/logo.png') no-repeat;
    background-size: contain;
  }

  a.login {
    line-height: 35px;
    display: inline-block;
    margin: 0 15px;
    color: #fff;
  }

  a.signup {
    color: #fff;
    margin: 0 15px;
  }

  a:hover {
    color: #11B8BB;
    transition: color 0.4s ease 0s;
  }

  .login_line {
    display: inline-block;
    height: 14px;
    width: 1px;
    background: #fff;
    vertical-align: middle;
  }

  .change_language {
    margin: 0 15px;
    line-height: 35px;
    display: inline-block;
    cursor: pointer;
    width: 90px;
    text-align: center;
  }

  .choose-language {
    position: absolute;
    left: 0;
    margin: 0 15px;
    z-index: 20000;
    width: 90px;
    text-align: center;

    a {
      color: #0db4c5;
      display: block;
    }
  }

  .download_tab, .resource_tab {
    margin: 0 15px;
    line-height: 35px;
    display: inline-block;
    cursor: pointer;
    color: #fff;
  }

  .show {
    display: block;
  }
}

@media (max-width: 640px) {
  .pc-header, .faq, .club {
    display: none;
  }

  .pc-login .faq, .club, .pc-login .resource_tab {
    display: none;
  }
}
</style>
